import {type ReactNode} from 'react';
import {Navigate, Outlet} from 'react-router-dom';

import {type Role} from '../modules/common/constants/roles';
import {routes} from '../modules/common/constants/routes';
import {useAuthStore} from '../modules/common/stores/authStore';

interface ProtectedRouteProps {
  roles?: Role[];
  conditionalRoles?: Role[][];
  children?: ReactNode;
}

export function ProtectedRoute({
  roles = [],
  conditionalRoles,
  children,
}: ProtectedRouteProps): JSX.Element | ReactNode {
  const checkRoles = useAuthStore((state) => state.checkRoles);

  if (conditionalRoles) {
    let canViewLink = false;

    for (const conditionalRole of conditionalRoles) {
      if (checkRoles(...conditionalRole)) {
        canViewLink = true;
        break;
      }
    }

    if (canViewLink) {
      if (children != null) {
        return children;
      }

      return <Outlet />;
    } else {
      return <Navigate to={routes.unauthorised} replace />;
    }
  } else {
    if (!checkRoles(...roles)) {
      return <Navigate to={routes.unauthorised} replace />;
    }

    if (children != null) {
      return children;
    }

    return <Outlet />;
  }
}
